type NavItem = {
  solutionId?: string;
  children?: NavItem[];
  visibleForUuids?: string[];
};

type EnabledSolution = {
  solution_uuid: string;
};

export const isNavItemDisabled = ({
  navItem,
  enabledSolutions,
  parentDisabled = false,
  mspGlobalOrganisationId,
}: {
  navItem: NavItem;
  enabledSolutions: EnabledSolution[];
  parentDisabled: boolean;
  mspGlobalOrganisationId?: string | null;
}): boolean => {
  if (navItem.visibleForUuids && mspGlobalOrganisationId) {
    if (navItem.visibleForUuids.includes(mspGlobalOrganisationId)) {
      return false;
    }
  }

  if (!navItem.solutionId) {
    return parentDisabled;
  }

  if (parentDisabled) {
    return true;
  }

  return !enabledSolutions.some(
    (solution: EnabledSolution) =>
      solution.solution_uuid === navItem.solutionId,
  );
};
